import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Form, Dropdown, ButtonGroup } from 'react-bootstrap';
import { TiTickOutline } from "react-icons/ti";
import './my-approved-leave.css';
import MyLeaveLayout from '../../Components/MyLeaveLayout.jsx';
import axios from 'axios';

// Number of rows per page
const rowsPerPage = 10;

export default function ApprovedLeave() {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState(''); // Added searchTerm state

  useEffect(() => {
    setLoading(true);
    setError(null);

    const userId = localStorage.getItem('userId'); // Get the userId from session storage

    if (!userId) {
      setError('User ID not found in session storage');
      setLoading(false);
      return;
    }

    // Fetch data from the backend with search and pagination functionality
    axios.get('https://backend.ems.hiradentallab.com/api/leaves/approved-leaves/user', {
      headers: { 'userId': userId },
      params: { 
        searchTerm, 
        page: currentPage, 
        rowsPerPage 
      },
    })
      .then((response) => {
        setData(response.data.approvedLeaves); // Set the response data
        setLoading(false);
      })
      .catch((error) => {
        setError('Error fetching approved leaves');
        setLoading(false);
      });
  }, [currentPage, searchTerm]); // Re-run when currentPage or searchTerm changes

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value); // Update search term dynamically
    setCurrentPage(1); // Reset to the first page on search
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className='container-fluid'>
      <MyLeaveLayout>
        <div>
          <h1 className="approved-leaves-header">
            <TiTickOutline className="icon-tick" />
            Approved Leave
          </h1>
          <hr />
          <div className="approved-leave-content">
            <div>
              <div className="entries-search-container" style={{ marginTop: 0 }}>
                <Row>
                  <Col xs={12} md={6} className="d-flex align-items-center">
                    <Dropdown as={ButtonGroup}>
                      <Button variant="primary">Show Entries</Button>
                      <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                        <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                        <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                        <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                  <Col xs={12} md={6} className="d-flex justify-content-end search-container">
                    <Form
                      className="d-flex"
                      onSubmit={(e) => e.preventDefault()} // Prevent default form submission
                    >
                      <Form.Control
                        type="search"
                        placeholder="Search"
                        aria-label="Search"
                        className="search-input"
                        value={searchTerm} // Bind input to searchTerm state
                        onChange={handleSearchChange} // Update searchTerm on input change
                      />
                    </Form>
                  </Col>
                </Row>
              </div>
              <div className="table-responsive">
                <table className='table table-striped'>
                  <thead className="approved-leave-table-header">
                    <tr>
                      <th>SR</th>
                      <th>Leave Type</th>
                      <th>Days</th>
                      <th>Description</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr><td colSpan="5" className="text-center">Loading...</td></tr>
                    ) : error ? (
                      <tr><td colSpan="5" className="text-center">{error}</td></tr>
                    ) : (
                      data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((item, index) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * rowsPerPage + index + 1}</td> {/* Dynamic SR Number */}
                          <td>{item.leaveType}</td>
                          <td>{item.days}</td>
                          <td>{item.reason}</td>
                          <td>{item.status}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                  <tfoot>
                    <tr className='approved-leave-table-footer'>
                      <td colSpan="5" className="text-center">
                        Total Entries: {data.length}
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div className="containerrrr">
                  <Row className="custom-row">
                    <Col xs={12} md={9} className="custom-col-left">
                      Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, data.length)} of {data.length} Entries
                    </Col>
                    <Col xs={12} md={3} className="custom-col-right">
                      <nav>
                        <ul className="pagination">
                          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <a
                              href="/#"
                              className="page-link"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePageChange(currentPage - 1);
                              }}
                            >
                              Previous
                            </a>
                          </li>
                          {pageRange().map(pageNumber => (
                            <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                              <a
                                href="/#"
                                className="page-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handlePageChange(pageNumber);
                                }}
                              >
                                {pageNumber}
                              </a>
                            </li>
                          ))}
                          <li className={`page-item ${currentPage === Math.ceil(data.length / rowsPerPage) ? 'disabled' : ''}`}>
                            <a
                              href="/#"
                              className="page-link"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePageChange(currentPage + 1);
                              }}
                            >
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MyLeaveLayout>
    </div>
  );
}
